export const createUseOrdersQueryParams = ({ currentPage, size, offerId, query, status, sales, types, filterOutGiveawayGifts, }) => ({
    page: currentPage - 1,
    size,
    offerIds: offerId ? [offerId] : undefined,
    status,
    sales,
    types,
    q: query,
    filterOutGiveawayGifts,
});
